(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDetailController', ExchangerateDetailController);

    ExchangerateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Exchangerate'];

    function ExchangerateDetailController($scope, $rootScope, $stateParams, previousState, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:exchangerateUpdate', function(event, result) {
            vm.exchangerate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
